export const Colors = {
  primary: '#2F55B8',
  primaryDark: '#162c66',
  primaryLight: '#D2D8E5',
  background: '#F4FAFF',
  text: '#11205E',

  white: '#ffffff',
  black: '#000000',
  grey: '#A1A4AF',
  lightGrey: '#B8BCCE',
  lighterGrey: '#f5f5f5',
  darkGrey: '#525664',
  darkerGrey: '#363636',
  red: '#b7244d',
  border: '#ccc'
};
